
namespace Matrix.Dashboards {

    export interface IWidgetDesignerDialog {
        getDatasetCode(id?: string): string;
        getDatasetColumns(then: (columns: Data.DataColumn[]) => void, property?: string): boolean;
        getDatasetEditor(id?: string): Serenity.ServiceLookupEditor;
        getEditor<TWidget = Serenity.Widget<any>>(id: string, widgetType: { new(...args: any[]): TWidget; }): TWidget;
    }
}